module.exports = __webpack_public_path__ + "static/media/sideguard.3e25e4f2.svg";